import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Responsive from 'react-responsive-decorator'
import { setVehicleBrand } from 'tw-oi-core/actions/VehicleActions'
import * as UserActions from 'tw-oi-core/actions/UserActions'
import { BRANDS } from '../config'
import { breakpoints } from '../components/Media'

import { Helmet } from 'react-helmet'
import classNames from 'classnames'
import ThemeRoute from './ThemeRoute'
import VehicleRedirect from './VehicleRedirect'
import LandingPage from './LandingPage'
import DivisionVehicles from './DivisionVehicles'
import Offline from './Offline'
import PwaPrompt from '../components/PwaPrompt'
import OfflineRouteRedirect from '../components/OfflineRouteRedirect'

import { UI, ROUTE } from '../config'
import { initAnalyticsOnce } from '../extras/initAnalytics'

import {
  HashRouter as Router,
  Switch,
  Route
} from 'react-router-dom'

import '../styles/App.scss'

class ThemeContainer extends Component {
  static propTypes = {
    currentBrand:PropTypes.object.isRequired,
    setVehicleBrand: PropTypes.func.isRequired,
    UserActions: PropTypes.shape({
      setMedia: PropTypes.func.isRequired,
    }).isRequired,
    media: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
      PropTypes.func
    ])
  }

  componentDidMount() {
    initAnalyticsOnce()

    const { media, UserActions: { setMedia } } = this.props

    media(breakpoints.desktop, () => {
      setMedia({ isDesktop: true, isLandscape: false })
    })
    media(breakpoints.mobile, () => {
      setMedia({ isDesktop: false, isLandscape: false })
    })
    media(breakpoints.mobileLandscape, () => {
      setMedia({ isDesktop: false, isLandscape: true })
    })
    media(breakpoints.mobilePortrait, () => {
      setMedia({ isDesktop: false, isLandscape: false })
    })
  }

  render() {
    const { currentBrand } = this.props

    return <React.StrictMode>
      <div className={classNames("container", "theme-forest-river")}>
        <Helmet>
          <title>{currentBrand?.title ? `${currentBrand.title} Owner's Kit` : UI.UNIFIED_APP_TITLE}</title>
        </Helmet>
        <Router>
          <OfflineRouteRedirect />
          <Switch>
            <Route path={'/vehicles/:id'} component={VehicleRedirect}/>
            <Route exact path={'/'} component={LandingPage}/>
            <Route exact path={ROUTE.OFFLINE} component={Offline}/>
            <Route path={'/divisions/:divisionKey/vehicles/:year?/:group?'} component={DivisionVehicles}/>
            <Route path={'/:brandKey'} render={props => <ThemeRoute {...{...this.props, ...props}}/>}/>
          </Switch>
        </Router>
        <PwaPrompt/>
      </div>
    </React.StrictMode>
  }
}

function mapStateToProps({vehicle:{ currentBrand }}) {

  const brand = BRANDS.find(brand => brand.name === currentBrand)

  return { currentBrand: brand }
}

function mapDispatchToProps(dispatch) {
  return {
    setVehicleBrand: bindActionCreators(setVehicleBrand, dispatch),
    UserActions: bindActionCreators(UserActions, dispatch),
  }
}

export default Responsive(connect(mapStateToProps, mapDispatchToProps)(ThemeContainer))
